import {NgModule} from '@angular/core';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';

@NgModule({
  imports: [
    AngularFireAuthModule
  ]
})
export class UnrAuthModule {
}
